var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Prop, Vue, } from "vue-property-decorator";
const colors = {
    top: "green",
    bendZones: "cyan",
    problematicGeometries: "red",
};
let ColorLegend = class ColorLegend extends Vue {
    get showColorMap() {
        return {
            top: true,
            bendZones: this.bendPart,
            problematicGeometries: this.problematicGeometries,
        };
    }
    get geometryColors() {
        return Object.keys(colors)
            .filter(key => this.showColorMap[key])
            .map(key => colors[key]);
    }
};
__decorate([
    Prop({ required: true })
], ColorLegend.prototype, "problematicGeometries", void 0);
__decorate([
    Prop({ required: true })
], ColorLegend.prototype, "bendPart", void 0);
__decorate([
    Inject()
], ColorLegend.prototype, "i18n", void 0);
ColorLegend = __decorate([
    Component({
        components: {},
        name: "ColorLegend",
    })
], ColorLegend);
export default ColorLegend;
